class BottomSheet {

    constructor(sheet){

        this.sheetHeight;
        this.lastSheetHeight = 50;
        this.dragPosition;

        this.sheet          = sheet;
        this.content        = this.sheet.querySelector(".sheet_content");
        this.sheetContents  = this.sheet.querySelector(".sheet_contents");
        this.draggableArea  = this.sheet.querySelector(".draggable-area");
        this.draggableLine  = this.sheet.querySelector(".draggable-line");

        this._init();

    }

    shown(){
        let self = this;
        self.setSheetHeight(Math.min(50, 720 / window.innerHeight * 100))
        self.setIsSheetShown(true)
    }

    _init(){
        let self = this;

        let closeBtn = self.sheet.querySelector(".close-sheet");

        if(closeBtn){
            closeBtn.addEventListener("click", () => {
                self.setIsSheetShown(false)
            })
        }

        let overlay = self.sheet.querySelector(".overlay");
        if(overlay){
            overlay.addEventListener("click", () => {
                self.setIsSheetShown(false)
            })
        }


        self.draggableArea.addEventListener("mousedown", (event) => {
            console.log("mousedown");
            self.onDragStart(event);
        })
        self.sheet.addEventListener("mouseup", (event) => {
            console.log("mouseup");
            self.onDragEnd(event);
        })

        self.draggableArea.addEventListener("touchstart", (event) => {
            console.log("touchstart");
            self.onDragStart(event);
        })
        self.sheet.addEventListener("touchend", (event) => {
            console.log("touchend");
            self.onDragEnd(event);
        })

        self.sheet.addEventListener("mousemove", (event) => {
            console.log("mousemove");
            self.onDragMove(event);
        })
        self.sheet.addEventListener("touchmove", (event) => {
            console.log("touchmove");
            self.onDragMove(event);
        })


    }

    setSheetHeight(value, fix){

        let self = this;

        self.sheetHeight = Math.max(0, Math.min(100, value));
        if(fix){
            self.lastSheetHeight = value;
        }
        self.sheetContents.style.height = self.sheetHeight + '%';

        if (self.sheetHeight === 100) {
            self.sheetContents.classList.add("fullscreen")
        } else {
            self.sheetContents.classList.remove("fullscreen")
        }
    }

    setIsSheetShown(value){
        if(!value){
            $(this.sheet).trigger('onClose');
        }
    }

    touchPosition(event){
        return event.touches ? event.touches[0] : event
    }

    onDragStart(event){

        let self = this;

        if(self.draggableLine !== event.target && self.content.scrollTop > 0) return;

        self.dragPosition = self.touchPosition(event).pageY;
        self.sheetContents.classList.add("not-selectable")
        self.draggableArea.style.cursor = document.body.style.cursor = "grabbing"
    }

    onDragMove(event){

        let self = this;

        if(self.dragPosition === undefined) return;
        if(self.draggableLine !== event.target && self.content.scrollTop > 0) return;

        self.content.scrollTop = 0;

        const y = self.touchPosition(event).pageY;
        const deltaY = self.dragPosition - y;
        const deltaHeight = deltaY / window.innerHeight * 100

        self.setSheetHeight(self.sheetHeight + deltaHeight)
        self.dragPosition = y
    }

    onDragEnd(event){

        let self = this;

        if(self.dragPosition === undefined) return;
        if(self.draggableLine !== event.target && self.content.scrollTop > 0) return;

        self.dragPosition = undefined
        self.sheetContents.classList.remove("not-selectable")
        self.draggableArea.style.cursor = document.body.style.cursor = ""

        self.content.scrollTop = 0;

        if(self.lastSheetHeight === 100){
            if(self.sheetHeight < 95){
                self.setSheetHeight(50, true);
            }
        }else if(self.lastSheetHeight === 50){
            if(self.sheetHeight < 45){
                self.setIsSheetShown(false)
            }else if(self.sheetHeight > 55){
                self.setSheetHeight(100, true)
            }else{
                self.setSheetHeight(50, true)
            }
        }else{
            self.setSheetHeight(50, true);
        }

    }

}

export default BottomSheet;